import { extendTheme } from '@chakra-ui/react';

export default extendTheme({
    colors: {
        brand: {
            mustard: '#CBA135',
            black: '#1b1b1b',
            orange: '#f46036',
            blue: '#6290C3',
            white: '#fdfffc',
            grey: '#fbfbfb',
            darkGrey: '#dedede'
        }
    }
});